import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';

import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import * as Sentry from '@sentry/angular';
import { CHRONICLE_UPSERT } from './share/chronicle/chronicle.service';
import { chronicleUpsert } from './share/chronicle/chronicle-sdk';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { environment } from '../environments/environment';
import { ApiModule, Configuration } from '../openapi-ts';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ActivityPageComponent } from './pages/activity-page/activity-page.component';
import { AppWrapperComponent } from './pages/app-wrapper/app-wrapper.component';
import { BirthdayCheckComponent } from './pages/birthday-check/birthday-check.component';
import { WithdrawalComponent } from './pages/withdrawal/withdrawal.component';
import { WithdrawalBankSelectorComponent } from './pages/withdrawal/components/withdrawal-bank-selector/withdrawal-bank-selector.component';
import { WithdrawalExternalRedirectComponent } from './pages/withdrawal/components/withdrawal-external-redirect/withdrawal-external-redirect.component';
import { WithdrawalApplicationSelectorComponent } from './pages/withdrawal/components/withdrawal-application-selector/withdrawal-application-selector.component';
import { WithdrawalInlineFormComponent } from './pages/withdrawal/components/withdrawal-inline-form/withdrawal-inline-form.component';
import { InfoPageComponent } from './pages/info-page/info-page.component';
import { CouponPanelTipComponent } from './pages/resultpage/coupon-panel/coupon-panel-tip/coupon-panel-tip.component';
import { CouponPanelComponent } from './pages/resultpage/coupon-panel/coupon-panel.component';
import { FilterComponent } from './pages/resultpage/filter/filter.component';
import { LoanComponent } from './pages/resultpage/filter/loan/loan.component';
import { MainFilterComponent } from './pages/resultpage/filter/main-filter/main-filter.component';
import { CustomerImprovementComponent } from './pages/resultpage/offer/customer-improvement/customer-improvement.component';
import { DefaultBoxComponent } from './pages/resultpage/offer/default-box/default-box.component';
import { OfferDetailsComponent } from './pages/resultpage/offer/offer-details/offer-details.component';
import { OfferComponent } from './pages/resultpage/offer/offer.component';
import { SmilyInfoboxComponent } from './pages/resultpage/offer/smily-infobox/smily-infobox.component';
import { SalesAgentBoxComponent } from './pages/resultpage/offer/sales-agent-box/sales-agent-box.component';
import { ResultpageComponent } from './pages/resultpage/resultpage.component';
import { TimeoutDialogComponent } from './pages/resultpage/timeout-dialog/timeout-dialog.component';
import { TestcaseComponent } from './pages/testcase/testcase.component';
import { ActiveComponent } from './pages/active/active.component';
import { ArchiveComponent } from './pages/archive/archive.component';
import { PeriodPipe } from './share/pipes/period.pipe';
import { ShareModule } from './share/share.module';

@NgModule({
  declarations: [
    AppComponent,
    ResultpageComponent,
    AppWrapperComponent,
    ActivityPageComponent,
    OfferDetailsComponent,
    FilterComponent,
    OfferComponent,
    SmilyInfoboxComponent,
    LoanComponent,
    MainFilterComponent,
    CustomerImprovementComponent,
    SalesAgentBoxComponent,
    DefaultBoxComponent,
    TestcaseComponent,
    InfoPageComponent,
    BirthdayCheckComponent,
    WithdrawalComponent,
    WithdrawalBankSelectorComponent,
    WithdrawalExternalRedirectComponent,
    WithdrawalApplicationSelectorComponent,
    WithdrawalInlineFormComponent,
    CouponPanelComponent,
    CouponPanelTipComponent,
    TimeoutDialogComponent,
    ActiveComponent,
    ArchiveComponent,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    ShareModule,
    BrowserModule,
    AppRoutingModule,
    OverlayModule,
    BrowserAnimationsModule,
    ApiModule.forRoot(
      () =>
        new Configuration({
          basePath: environment.basePath,
          credentials: { 'api-key': 'check24at' },
        })
    ),
    AngularSvgIconModule.forRoot(),
    PeriodPipe,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    provideHttpClient(withInterceptorsFromDi()),
    { provide: CHRONICLE_UPSERT, useValue: chronicleUpsert },
  ],
})
export class AppModule {}
